/**
 * External dependencies
 */

import { get, values } from 'lodash';


export const getAllRoamPlans = (state) => values(get(state, ['roamPlans', 'items']));

export const requestingRoamPlans = (state) => get(state, ['roamPlans', 'requesting']);

export const errorRequestingRoamPlans = (state) => get(state, ['roamPlans', 'error']);